import React from 'react';

import { getAppUIVariantConfig } from 'Util/uiVariantSet';
import { AccessContentModal, MESSAGE_TYPE } from 'Components/AccessContentModal';

const ConcurrentModal = ({ isError, onContinue }) => {
  const { Modal } = getAppUIVariantConfig();

  switch (Modal) {
    case 'Rounded':
    default: {
      return (
        <AccessContentModal
          muiProps={{
            isActive: isError,
          }}
          messageType={MESSAGE_TYPE.CONCURRENT_USER}
          onClick={onContinue}
        />
      );
    }
  }
};

export default ConcurrentModal;
